export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9725.31b0f9d6.jpg";